import React, { Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import { Supplementarymaterialforinstructor } from "../../SuperAdmin/Materialinstructor/Supplementarymaterialforinstructor";
import PageNotFound from "../../error/PageNotFound";
import PageLoader from "../../loader/PageLoader";
import ProtectedSuperAdminLayout from "../../layouts/ProtectedSuperAdminLayout";
import Category from "../../SuperAdmin/Category/Category";
import AdminPageIndex from "../../SuperAdmin/AdminManagement/AdminPageIndex";
import PaymentDetailsIndex from "../../SuperAdmin/PaymentDetails/PaymentDetailsIndex";
import SupportIndex from "../../SuperAdmin/Support/SupportIndex";
import AccountIndex from "../../SuperAdmin/AccountSettings/AccountIndex";
import AdminProfileView from "../../SuperAdmin/AdminManagement/AdminProfileView";
import ReleaseNots from "../../SuperAdmin/Introduction/ReleaseNots";

const SuperAdminRoutes = () => {
  return (
    <Suspense fallback={<PageLoader />}>
      <Routes>
        <Route path="/" element={<ProtectedSuperAdminLayout />}>
          <Route path="ReleaseNotes" element={<ReleaseNots />} />
          <Route path="paymentDetails" element={<PaymentDetailsIndex />} />
          <Route path="adminControls" element={<AdminPageIndex />} />
          <Route path="adminControls/:profile" element={<AdminProfileView />} />
          <Route path="category" element={<Category />} />
          <Route path="support" element={<SupportIndex />} />
          <Route path="accountSettings" element={<AccountIndex />} />
          <Route
            path="Supplementarymaterialforinstructor"
            element={<Supplementarymaterialforinstructor />}
          />
          <Route path="*" element={<PageNotFound />} />
        </Route>
      </Routes>
    </Suspense>
  );
};

export default SuperAdminRoutes;
